import { HttpParams } from "@angular/common/http";
/** @format */

import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";
import { DrawerRef } from "mis-design-system/drawer";
import { DRAWER_DATA_VAR } from "mis-design-system/drawer";
import { DeleteConfirmationComponent } from "../../forms/delete-confirmation/delete-confirmation.component";
import { Observable, Subject } from "rxjs";
import { ConnectionPositionPair, Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { take } from "rxjs/operators";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { ConfigurationService } from "../../../services/configuration.service";
import { getAdditionalBookings, parkingTypes } from "../../../functions/booking-utils.functions";
import { ModalService } from "mis-design-system/mis-modal";
import { NsExpWidget } from "../../../models/widgets.models";
import { CommuteService } from "../../../services/commute.service";
import { LoaderService } from "../../../services/loader.service";
import { ApiService } from "../../../services/api.service";
import { ToastService } from "mis-crystal-design-system/toast";
import * as moment from "moment";
import { MealFeedbackModalComponent } from "../meal-feedback-modal/meal-feedback-modal.component";
@Component({
  selector: "mis-employee-web-exp-upcoming-bookings",
  templateUrl: "upcoming-bookings.component.html",
  styleUrls: ["upcoming-bookings.component.scss"]
})
export class UpcomingBookingsComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  booking: NsEmpWebExpData.IBookingDetailDTOS;
  formHeading = "Your Booking";
  endObs = new Subject<void>();
  opt: boolean = false;
  loginOptPlace: string = "";
  logoutOptPlace: string = "";
  overlayRef: OverlayRef;
  configs: NsWISConfigurations.IConfigurations;
  offices = this.bookingSvc.offices;
  bookingPermissionStream: Observable<NsExpWidget.IBookingValidity>;
  meal = [];
  mealEnitity: NsEmpWebExpData.IMealsEntity[] = [];
  mealEnabled = false;
  parkingData: NsEmpWebExpData.IParkingDetails;
  enableWaitlistBooking: boolean;
  enableJoinAllWaitlist: boolean;
  waitingPremises: NsEmpWebExpData.IParkingPremise[] = [];
  isLoading: boolean = false;
  enableMealFeedBack: boolean = true;
  noOfStars: number = 5;
  mealSelectedRating: number = 0;
  mealOverallRating: number = 0;
  mealRated: boolean = false;
  mealFeedbackMoalData: NsEmpWebExpData.IMealFeedbackModalInfo;
  mealFeedbackOptions: NsWISConfigurations.IMealFeedBackOptions;
  mealTypeList: NsEmpWebExpData.IMealData[];
  projectCode: string = '';
  projectCodeEnabledOnBooking: boolean = false;


  specialRequests;
  constructor(
    private bookingSvc: BookingDataService,
    public drawerRef: DrawerRef,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private modals: ModalService,
    @Inject(DRAWER_DATA_VAR) data,
    private configSvc: ConfigurationService,
    private commuteSvc: CommuteService,
    private loader: LoaderService,
    private apiService: ApiService,
    private toast: ToastService
  ) {
    this.loader.show();
    if (!data || !data.booking || !data.configs) {
      throw new Error("You need to inject data");
    }
    this.booking = data.booking;
    this.configs = data.configs;
    this.bookingPermissionStream = this.configSvc.applyOfficeConfigurations(this.booking);
  }

  ngOnInit(): void {
    const parking = getAdditionalBookings(this.booking, parkingTypes);
    this.projectCode = !!this.booking?.extras?.projectCode ? this.booking?.extras?.projectCode : ''; 
    let fetchWaitList = parking && parking?.[0]?.typeWiseWaitingList !== null ? Object.keys(parking?.[0]?.typeWiseWaitingList).length > 0 : false;
    if (fetchWaitList) {
      this.fetchPremises(parking[0]);
    } else {
      this.parkingData = parking
        ? {
            tokenId: parking[0].tokenId,
            tokenName: parking[0].tokenName,
            premiseType: parking[0].premiseType === "PARKING_FOUR" ? "CAR" : "BIKE",
            premiseName: parking[0].premiseName
          }
        : null;
    }
    this.mealEnabled = this.configs.flattenedSettings.mealPlanningEnabled;
    this.specialRequests = this.booking?.specialRequests;
    const mealData = getAdditionalBookings(this.booking, ["MEALS"])?.[0]?.extras;
    mealData ? (this.meal = [mealData as NsEmpWebExpData.IMeal]) : (this.meal = undefined);
    this.mealEnitity = !!this.meal && this.meal.length > 0  ? (!!this.meal?.[0]?.mealData ? [...this.meal?.[0]?.mealData] : undefined) : undefined;
    this.loginOptPlace = this.transportOptSetter("LOGIN") ? "Cab" : undefined;
    this.logoutOptPlace = this.transportOptSetter("LOGOUT") ? "Cab" : undefined;
    this.opt = this.loginOptPlace || this.logoutOptPlace ? true : false;
    this.enableWaitlistBooking = this.configs.flattenedSettings.enableWaitlistBooking;
    this.enableJoinAllWaitlist = this.configs.flattenedSettings.enableJoinAllWaitlist;
    this.projectCodeEnabledOnBooking = !!this.configs.flattenedSettings.projectCodeEnabledOnBooking ? this.configs.flattenedSettings.projectCodeEnabledOnBooking : false;
    this.enableMealFeedBack = this.booking.requestStatus !== 'CANCELLED' && this.configs.flattenedSettings.mealFeedbackEnabled && !!mealData && !!mealData?.mealData && mealData.mealData.length > 0 && moment(this.booking?.endTime).tz(this.booking?.timezone || 'Asia/Kolkata').isBefore(moment().tz(this.booking?.timezone || 'Asia/Kolkata'));
    this.mealFeedbackOptions = this.configs.flattenedSettings.mealFeedbackOptions;
    this.mealTypeList = !!mealData && !!mealData?.mealData && mealData.mealData.length > 0 ? 
      mealData.mealData.map((item: any) => ({
        mealId: item.mealId,
        mealName: item.name
      })) : []
      this.mealOverallRating = !!mealData && !!mealData.overallRating ? mealData.overallRating : 0;
      this.mealRated = !!this.mealOverallRating && this.mealOverallRating > 0;
  }

  selectedRating(event){
    this.mealSelectedRating = event;
    this.mealFeedbackMoalData = {
      bookingId: !!getAdditionalBookings(this.booking, ["MEALS"])?.[0]?.bookingId ? getAdditionalBookings(this.booking, ["MEALS"])?.[0]?.bookingId : '',
      bookingDate: moment(this.booking.startTime).tz(this.booking.timezone).format('DD/MM/YYYY'),
      overallRating: this.mealSelectedRating,
      mealData: this.mealTypeList,
      mealFeedBackOptions: this.mealFeedbackOptions
    }
    const mealRef = this.modals.show(MealFeedbackModalComponent, this.mealFeedbackMoalData);
    mealRef.afterClosed.subscribe((res: any) => {
      if(!!res && res){
        this.drawerRef.close('MEAL_FEEDBACK');
      }
      else{
        this.drawerRef.close();
      }
    })
  }

  checkOnlyParkingEnabled() {
    return this.booking.bookingRequestType !== "OFFICE"
      ? true
      : !(!!this.configs.flattenedSettings?.onlyParkingBookingEnabled && this.configs.flattenedSettings?.onlyParkingBookingEnabled);
  }

  fetchPremises(parkingBooking: NsEmpWebExpData.IBookingDetailDTOS): void {
    const premiseIds = Object.keys(parkingBooking?.typeWiseWaitingList);
    const officeGuid = this.booking?.officeId;
    const startTime = this.booking?.startTime;
    const endTime = this.booking?.endTime;
    if (premiseIds.length) {
      this.isLoading = true;
      let params = new HttpParams();
      params = params.append("isHybridParking", "true");
      this.apiService.getWaitingCount(startTime, endTime, premiseIds, officeGuid, params).subscribe(
        res => {
          this.isLoading = false;
          let wlPremises = res;
          let waiting = [];
          let carList = JSON.parse(JSON.stringify(wlPremises));
          let bikeList = JSON.parse(JSON.stringify(wlPremises));
          carList.forEach(item => {
            if (parkingBooking?.typeWiseWaitingList?.hasOwnProperty(item.premiseId)) {
              if (parkingBooking?.typeWiseWaitingList[item.premiseId].includes("PARKING_FOUR")) {
                item.isChecked = true;
                item.waitListType = "CAR";
                waiting.push(item);
              }
            }
          });

          bikeList.forEach(item => {
            if (parkingBooking?.typeWiseWaitingList?.hasOwnProperty(item.premiseId)) {
              if (parkingBooking?.typeWiseWaitingList[item.premiseId].includes("PARKING_TWO")) {
                item.isChecked = true;
                item.waitListType = "BIKE";
                waiting.push(item);
              }
            }
          });

          parkingBooking.waitingPremises = waiting;
          this.waitingPremises = waiting;
        },
        err => {
          this.isLoading = false;
          this.toast.displayMsg("Unable to fetch Waiting Count.");
        }
      );
    }
  }
  transportOptSetter(direction: string) {
    return (
      (this.booking.requestStatus !== "CANCELLED" &&
        this.booking.userRequestDTOS.find(
          item => item?.direction === direction && (item?.status === "SCHEDULED" || item?.status === "CAB_ALLOCATED")
        )) ||
      (this.booking.requestStatus === "CANCELLED" && this.booking.userRequestDTOS.find(item => item?.direction === direction))
    );
  }
  showMenu(template: TemplateRef<ElementRef>, origin: HTMLElement): void {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(origin)
      .withPositions([new ConnectionPositionPair({ originX: "end", originY: "top" }, { overlayX: "end", overlayY: "bottom" })])
      .withPush(true);
    const config = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      backdropClass: "cdk-overlay-transparent-backdrop"
    });
    this.overlayRef = this.overlay.create(config);
    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef));
    // componentInstance.instance
    this.overlayRef
      .backdropClick()
      .pipe(take(1))
      .subscribe(res => {
        this.overlayRef.detach();
        this.overlayRef.dispose();
      });
  }

  close() {
    this.drawerRef.close();
  }

  closeMenu(type: "Edit" | "Cancel" | "Convert"): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
    if (type === "Cancel") {
      this.modals.show(DeleteConfirmationComponent);
      this.close();
    } else if (type === "Edit") {
      this.drawerRef.close(this.booking);
    } else if (type === "Convert") {
      this.drawerRef.close({
        ...this.booking,
        bookingRequestType: this.booking.bookingRequestType === "OFFICE" ? "WFH" : "OFFICE",
        mode: "CONVERT"
      });
    }
  }
}
